/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ExternalStyles, Text } from 'bold-ui'
import { resolveName, SimNaoRadioGroupField, TextField } from 'components/form'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'
import { isEmpty } from 'util/validation/Util'

import { ConsultaSeguimentoOutroFieldModel } from '../model-consultaSeguimento'

interface PerguntaSimNaoOutroFieldProps {
  name: MetaPath<ConsultaSeguimentoOutroFieldModel>
  direction?: 'horizontal' | 'vertical'
  hideRadioOptions?: boolean
  style?: ExternalStyles
}

export function PerguntaSimNaoOutroField(props: Readonly<PerguntaSimNaoOutroFieldProps>) {
  const { name, direction = 'horizontal', hideRadioOptions, style } = props

  const styles = createStyles(direction)

  const {
    input: { value },
  } = useField<ConsultaSeguimentoOutroFieldModel>(resolveName(name), { subscription: { value: true } })

  return (
    <div css={[styles.root, style]}>
      <TextField
        name={name.textValue}
        label={<Text fontWeight='normal'>Outro:</Text>}
        maxLength={150}
        placeholder='Descrever, se houver'
        style={styles.textField}
      />
      {!hideRadioOptions && (
        <SimNaoRadioGroupField name={name.radioValue} hSpacing={0.5} disabled={isEmpty(value.textValue)} />
      )}
    </div>
  )
}

const createStyles = (direction: 'horizontal' | 'vertical') => ({
  root: css`
    display: grid;
    gap: 1rem;
    grid-auto-flow: ${direction === 'horizontal' ? 'column' : 'row'};
    align-items: center;
    justify-content: ${direction === 'horizontal' ? 'space-between' : 'normal'};
  `,
  textField: css`
    width: ${direction === 'horizontal' ? '27rem' : '100%'};
  `,
})
